import { render, staticRenderFns } from "./Sucess.vue?vue&type=template&id=31880392&scoped=true"
import script from "./Sucess.vue?vue&type=script&lang=js"
export * from "./Sucess.vue?vue&type=script&lang=js"
import style0 from "./Sucess.vue?vue&type=style&index=0&id=31880392&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31880392",
  null
  
)

export default component.exports